import axios from '../index'

export default {
    getInstitucion () {
        return axios.get('/instituciones/usuario/')
    },
    getCiclosEscolares(institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/' + institucionId)
    },
    getGrupo(institucionId, params) {
        return axios.get('/grupos-administrativos/gruposInstitucion/' + institucionId,{
            params
        })
    },
    getDestinatarios(params){
        return axios.post('/api/v1/mailing/recipients', params)
    },
    getTemplate(formData){
        return axios.post('/api/v1/mailing/mail', formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    getActualizar(formData){
        return axios.post('/api/v1/mailing/update', formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    getGuardados(params){
        return axios.get('/api/v1/mailing/mails',{
            params
        })
    },
    getEnviados(params){
        return axios.post('/api/v1/mailing/mails', params)
    },
    removeFile(params){
        return axios.get('/api/v1/mailing/delete-attachment',{
            params
        })
    },
    getEnviarDatos(payload){
        return axios.post('/api/v1/mailing/sendmail', payload)
    }
}